var chunkMapping = {
	"0": [
		4647
	],
	"74": [
		5051
	],
	"150": [
		5127
	],
	"151": [
		5128
	],
	"154": [
		5131
	],
	"155": [
		5132
	],
	"156": [
		5133
	],
	"157": [
		5134
	],
	"158": [
		5135
	],
	"159": [
		5136
	],
	"160": [
		5137
	],
	"161": [
		5138
	],
	"162": [
		5139
	],
	"163": [
		5140
	],
	"164": [
		5141
	],
	"165": [
		5142
	],
	"166": [
		5143
	],
	"167": [
		5144
	],
	"168": [
		5145
	],
	"169": [
		5146
	],
	"170": [
		5147
	]
};
var idToExternalAndNameMapping = {
	"4647": [
		"default",
		"./Containers",
		3796
	],
	"5051": [
		"default",
		"./OrderlessInvoices",
		3796
	],
	"5127": [
		"default",
		"./AsyncEventTracker",
		3796
	],
	"5128": [
		"default",
		"./HostWrapper",
		3796
	],
	"5131": [
		"default",
		"./CheckoutV3",
		3796
	],
	"5132": [
		"default",
		"./CheckoutConfirmation",
		3796
	],
	"5133": [
		"default",
		"./ContactCreditCards",
		3796
	],
	"5134": [
		"default",
		"./AuditDialog",
		3796
	],
	"5135": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3796
	],
	"5136": [
		"default",
		"./InvoiceDialog",
		3796
	],
	"5137": [
		"default",
		"./PaymentDueModal",
		3796
	],
	"5138": [
		"default",
		"./PaymentModal",
		3796
	],
	"5139": [
		"default",
		"./PaymentHistory",
		3796
	],
	"5140": [
		"default",
		"./PaymentConfigurations",
		3796
	],
	"5141": [
		"default",
		"./PaymentPreferences",
		3796
	],
	"5142": [
		"default",
		"./ManagePaymentProcessing",
		3796
	],
	"5143": [
		"default",
		"./MobilePaymentsWrapper",
		3796
	],
	"5144": [
		"default",
		"./Challenge",
		3796
	],
	"5145": [
		"default",
		"./ManagePaymentMethods",
		3796
	],
	"5146": [
		"default",
		"./LightspeedReports",
		3796
	],
	"5147": [
		"default",
		"./ShippingPromotionsListContainer",
		3796
	]
};
var idToRemoteMap = {
	"4647": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5051": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5127": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5128": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5132": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5133": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5134": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5135": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5142": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5143": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5144": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5145": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5146": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5147": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}